import { CampanhaROI, newCampanhaROI } from '../roi';

/** Representa os resultados das campanhas */
export interface CampanhaResultado {
    /** Vendas **/
    // Pedidos Vendas
    quantidadePedidosVendas: number;
    quantidadePedidosVendasNaoLiberados: number;
    quantidadeTotalPedidosVendas: number;
    valorTotalPedidosVendas: number;

    /** Despesas => Recursos + Pedidos Bonificações **/
    // Recursos
    valorInvestimentosRecursos: number;
    valorProdutosRecursos: number;
    valorServicosRecursos: number;
    valorTotalRecursos: number;
    // Pedidos Bonificações
    quantidadePedidosBonificacoes: number;
    quantidadePedidosBonificacoesNaoLiberados: number;
    quantidadeTotalPedidosBonificacoes: number;
    valorTotalPedidosBonificacoes: number;
    // Total das despesas
    valorTotalDespesas: number;

    /** Leads */
    quantidadeLeadsCadastros: number;
    quantidadeLeadsQualificacoes: number;

    /** Clientes **/
    quantidadeClientesCadastros: number;
    quantidadeClientesAquisicoes: number;

    /** ROI **/
    roi?: CampanhaROI;
}

/** Cria um novo resultado de campanha */
export function createResultado(): CampanhaResultado {
    return {
        // Pedidos Vendas
        quantidadePedidosVendas: 0,
        quantidadePedidosVendasNaoLiberados: 0,
        quantidadeTotalPedidosVendas: 0,
        valorTotalPedidosVendas: 0,
        // Recursos
        valorInvestimentosRecursos: 0,
        valorProdutosRecursos: 0,
        valorServicosRecursos: 0,
        valorTotalRecursos: 0,
        // Pedidos Bonificações
        quantidadePedidosBonificacoes: 0,
        quantidadePedidosBonificacoesNaoLiberados: 0,
        quantidadeTotalPedidosBonificacoes: 0,
        valorTotalPedidosBonificacoes: 0,
        // Total das despesas
        valorTotalDespesas: 0,
        // Leads
        quantidadeLeadsCadastros: 0,
        quantidadeLeadsQualificacoes: 0,
        // Clientes
        quantidadeClientesCadastros: 0,
        quantidadeClientesAquisicoes: 0,

        // ROI
        roi: newCampanhaROI(0, 0, 0)
    }
}

/** Soma o resultado 1 e o resultado 2 */
export function sumResultado(resultado1: CampanhaResultado, resultado2: CampanhaResultado, roiPontoEquilibrio: number): CampanhaResultado {
    const resultado: CampanhaResultado = {
        /** Vendas **/
        // Pedidos Vendas
        quantidadePedidosVendas: (resultado1?.quantidadePedidosVendas ?? 0) + (resultado2?.quantidadePedidosVendas ?? 0),
        quantidadePedidosVendasNaoLiberados: (resultado1?.quantidadePedidosVendasNaoLiberados ?? 0) + (resultado2?.quantidadePedidosVendasNaoLiberados ?? 0),
        quantidadeTotalPedidosVendas: (resultado1?.quantidadeTotalPedidosVendas ?? 0) + (resultado2?.quantidadeTotalPedidosVendas ?? 0),
        valorTotalPedidosVendas: (resultado1?.valorTotalPedidosVendas ?? 0) + (resultado2?.valorTotalPedidosVendas ?? 0),

        /** Despesas => Recursos + Pedidos Bonificações **/
        // Recursos
        valorInvestimentosRecursos: (resultado1?.valorInvestimentosRecursos ?? 0) + (resultado2?.valorInvestimentosRecursos ?? 0),
        valorProdutosRecursos: (resultado1?.valorProdutosRecursos ?? 0) + (resultado2?.valorProdutosRecursos ?? 0),
        valorServicosRecursos: (resultado1?.valorServicosRecursos ?? 0) + (resultado2?.valorServicosRecursos ?? 0),
        valorTotalRecursos: (resultado1?.valorTotalRecursos ?? 0) + (resultado2?.valorTotalRecursos ?? 0),
        // Pedidos Bonificações
        quantidadePedidosBonificacoes: (resultado1?.quantidadePedidosBonificacoes ?? 0) + (resultado2?.quantidadePedidosBonificacoes ?? 0),
        quantidadePedidosBonificacoesNaoLiberados: (resultado1?.quantidadePedidosBonificacoesNaoLiberados ?? 0) + (resultado2?.quantidadePedidosBonificacoesNaoLiberados ?? 0),
        quantidadeTotalPedidosBonificacoes: (resultado1?.quantidadeTotalPedidosBonificacoes ?? 0) + (resultado2?.quantidadeTotalPedidosBonificacoes ?? 0),
        valorTotalPedidosBonificacoes: (resultado1?.valorTotalPedidosBonificacoes ?? 0) + (resultado2?.valorTotalPedidosBonificacoes ?? 0),
        // Total das despesas
        valorTotalDespesas: (resultado1?.valorTotalDespesas ?? 0) + (resultado2?.valorTotalDespesas ?? 0),

        /** Leads */
        quantidadeLeadsCadastros: (resultado1?.quantidadeLeadsCadastros ?? 0) + (resultado2?.quantidadeLeadsCadastros ?? 0),
        quantidadeLeadsQualificacoes: (resultado1?.quantidadeLeadsQualificacoes ?? 0) + (resultado2?.quantidadeLeadsQualificacoes ?? 0),

        /** Clientes **/
        quantidadeClientesCadastros: (resultado1?.quantidadeClientesCadastros ?? 0) + (resultado2?.quantidadeClientesCadastros ?? 0),
        quantidadeClientesAquisicoes: (resultado1?.quantidadeClientesAquisicoes ?? 0) + (resultado2?.quantidadeClientesAquisicoes ?? 0),
    }

    resultado.roi = newCampanhaROI(resultado.valorTotalPedidosVendas, resultado.valorTotalDespesas, roiPontoEquilibrio);
    return resultado;
}

/** Subtrai o resultado 1 pelo resultado 2 */
export function subResultado(resultado1: CampanhaResultado, resultado2: CampanhaResultado, roiPontoEquilibrio: number): CampanhaResultado {
    const resultado: CampanhaResultado = {
        /** Vendas **/
        // Pedidos Vendas
        quantidadePedidosVendas: (resultado1?.quantidadePedidosVendas ?? 0) - (resultado2?.quantidadePedidosVendas ?? 0),
        quantidadePedidosVendasNaoLiberados: (resultado1?.quantidadePedidosVendasNaoLiberados ?? 0) - (resultado2?.quantidadePedidosVendasNaoLiberados ?? 0),
        quantidadeTotalPedidosVendas: (resultado1?.quantidadeTotalPedidosVendas ?? 0) - (resultado2?.quantidadeTotalPedidosVendas ?? 0),
        valorTotalPedidosVendas: (resultado1?.valorTotalPedidosVendas ?? 0) - (resultado2?.valorTotalPedidosVendas ?? 0),

        /** Despesas => Recursos + Pedidos Bonificações **/
        // Recursos
        valorInvestimentosRecursos: (resultado1?.valorInvestimentosRecursos ?? 0) - (resultado2?.valorInvestimentosRecursos ?? 0),
        valorProdutosRecursos: (resultado1?.valorProdutosRecursos ?? 0) - (resultado2?.valorProdutosRecursos ?? 0),
        valorServicosRecursos: (resultado1?.valorServicosRecursos ?? 0) - (resultado2?.valorServicosRecursos ?? 0),
        valorTotalRecursos: (resultado1?.valorTotalRecursos ?? 0) - (resultado2?.valorTotalRecursos ?? 0),

        // Pedidos Bonificações
        quantidadePedidosBonificacoes: (resultado1?.quantidadePedidosBonificacoes ?? 0) - (resultado2?.quantidadePedidosBonificacoes ?? 0),
        quantidadePedidosBonificacoesNaoLiberados: (resultado1?.quantidadePedidosBonificacoesNaoLiberados ?? 0) - (resultado2?.quantidadePedidosBonificacoesNaoLiberados ?? 0),
        quantidadeTotalPedidosBonificacoes: (resultado1?.quantidadeTotalPedidosBonificacoes ?? 0) - (resultado2?.quantidadeTotalPedidosBonificacoes ?? 0),
        valorTotalPedidosBonificacoes: (resultado1?.valorTotalPedidosBonificacoes ?? 0) - (resultado2?.valorTotalPedidosBonificacoes ?? 0),
        // Total das despesas
        valorTotalDespesas: (resultado1?.valorTotalDespesas ?? 0) - (resultado2?.valorTotalDespesas ?? 0),

        /** Leads **/
        quantidadeLeadsCadastros: (resultado1?.quantidadeLeadsCadastros ?? 0) - (resultado2?.quantidadeLeadsCadastros ?? 0),
        quantidadeLeadsQualificacoes: (resultado1?.quantidadeLeadsQualificacoes ?? 0) - (resultado2?.quantidadeLeadsQualificacoes ?? 0),

        /** Clientes **/
        quantidadeClientesCadastros: (resultado1?.quantidadeClientesCadastros ?? 0) - (resultado2?.quantidadeClientesCadastros ?? 0),
        quantidadeClientesAquisicoes: (resultado1?.quantidadeClientesAquisicoes ?? 0) - (resultado2?.quantidadeClientesAquisicoes ?? 0),
    }

    resultado.roi = newCampanhaROI(resultado.valorTotalPedidosVendas, resultado.valorTotalDespesas, roiPontoEquilibrio);
    return resultado;
}
